"use client"

import MixtapeIcon from "@/components/icons/Mixtape"
import PlaylistCardInfo from "./PlaylistCardInfo"

type Props = {
  src?: string
  active?: boolean
  title?: string
  duration?: string
}

export default function PlaylistCardImageCanvas({
  src,
  active = false,
  title = "",
  duration = "",
}: Props) {
  if (!active) return null

  return (
    <div
      className="
        absolute
        inset-0
        z-20
        overflow-hidden
        rounded-lg active:scale-[90%]
        pointer-events-none border-t border-b border-[var(--primary)]/45

        pointer-events-auto        /* ⭐ ahora sí recibe el touch */
        active:scale-95            /* ⭐ efecto de presión */
        touch-active:scale-95      /* ⭐ soporte táctil real */
        transition-transform       /* ⭐ suavidad */
      "
    >
      {/* IMAGEN */}
      {src && (
        <img
          src={src}
          alt=""
          draggable={false}
          className="
            absolute
            bg-[var(--soft-bg)]
            inset-0 p-[0rem]
            h-full
            w-full
            rounded-lg
            object-cover
          "
        />
      )}

      {/* OSCURECIMIENTO */}
      {/* <div
        className="
          absolute
          inset-0
          bg-gradient-to-b
          from-transparent
          via-black/5
          //to-black/80
          to-[var(--color-sombra)]/80
          z-0  mx-[0rem] bottom-[0rem]
          //border-b  border-[var(--primary)]
        "
      /> */}


      {/* <div
        className="
          absolute
          inset-0
          bg-gradient-to-b
          from-transparent
          via-white/0
          to-[var(--primary)]/20
          z-0  mx-[0rem] bottom-[0rem]
        "
      /> */}

      {/* ICONO MIXTAPE */}
      <div
        className="
          absolute
          left-0
          top-0
          z-30
          p-1.5
        "
      >
        <MixtapeIcon
          className="
            h-2.5
            w-2.5
            text-white
            drop-shadow-[0_0_4px_rgba(0,0,0,.9)]
          "
        />
      </div>

      {/* INFORMACIÓN */}
      <div
        className="
          absolute
          inset-x-0
          bottom-0
          z-30
          w-full
          px-[.3rem]
          pb-[.3rem]
        "
      >
        <PlaylistCardInfo
          title={title}
          duration={duration}
        />
      </div>
    </div>
  )
}